/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Bold_Cat_JumpInputs */

const en_true_bold_cat_jump = /** @type {(inputs: True_Bold_Cat_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Survey round reminder`)
};

const de_true_bold_cat_jump = /** @type {(inputs: True_Bold_Cat_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinnerung Befragungsrunde`)
};

/**
* | output |
* | --- |
* | "Survey round reminder" |
*
* @param {True_Bold_Cat_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_bold_cat_jump = /** @type {((inputs?: True_Bold_Cat_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Bold_Cat_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_bold_cat_jump(inputs)
	return de_true_bold_cat_jump(inputs)
});